export function capitalizeFirstLetter(string?: string | null) {
  if (typeof string !== "string" || string.length === 0) {
    return string; // Handle empty strings or non-string inputs
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Converts a collection name to a slug by replacing spaces with underscores
 * Preserves the original case of the name
 * @param name - The collection name (e.g., "Sports Drinks")
 * @returns The slugified name (e.g., "Sports_Drinks")
 */
export function nameToSlug(name: string): string {
  return name.replace(/ /g, "_");
}

/**
 * Converts a slug back to a collection name
 * Reverses the nameToSlug transformation: replaces underscores with spaces
 * Preserves the original case of the slug
 * @param slug - The slugified name (e.g., "Sports_Drinks")
 * @returns The original name (e.g., "Sports Drinks")
 */
export function slugToName(slug: string): string {
  return slug.replace(/_/g, " ");
}
